require('../../libs/backbone/backbone.ajaxq.adapter.ts');
var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/patients.template.htm');
var PatientsTable = require('text-loader!../templates/patients_table.template.htm');
var Collection = require('../models/patients.paginated.collection.ts');
require('dhtmlxMessage');
var Pagination = require('../views/pagination.view.ts');
var HandlebarsHelpers = require('../../libs/handlebars/handlebars-helpers.ts');
var i18n = require("l10n");
var popup = require('popup');

var TheView = GenericView.extend({
    el: $("#container"),
    tagName: 'div',
	template: Handlebars.compile(Template),
	patientsTable: Handlebars.compile(PatientsTable),
	superInitialize: GenericView.prototype.initialize,
    collection : null,
    userData: null,
	privilegeLevel: "",
	isFirstDisplay: true,
	lastSearchedText: "",
	initialize: function (options) {
        var self = this;

        this.userData = options.data;
        this.privilegeLevel = this.privilegeLevelToNumber(this.userData.privilegeLevel);

        this.collection = new Collection();
        // TODO: change url into kiosks 
        this.collection.url = '/rest/api/customers/get';
        this.collection.on( 'sync', this.successPatientsData, this );
        this.collection.on( 'error', this.errorPatientsData, this );
        this.collection.getFirstPage();
	},
	superRender: GenericView.prototype.render,
	render: function () {
		this.superRender();

		this.$el.html(this.template({ privilegeLevel: this.privilegeLevel }));
	},
	events: {
        "click .edit_patient": "editPatient",
        "click .delete_patient": "deletePatient",
        "keyup #search": "search",
        "click #deleteBtn": "deletePatient"
	},
    search: function(event)
    {
        element = $(event.currentTarget);
		var text = element.val().trim();
        // TODO: change urls
        if(this.lastSearchedText != text )
        {
            $.ajaxq.abort("DefaultQueue");
            this.lastSearchedText = text;
            this.collection.url = '/rest/api/customers/get?q=' + encodeURIComponent(element.val().trim());
            this.collection.getFirstPage();
        }
    },
    successPatientsData: function()
    {
        var self = this;
        self.hideActionProgressBar();

        if(this.isFirstDisplay)
        {
            this.isFirstDisplay = false;
            this.render();
            if(this.collection.models.length == 0)
                $('#search-container').hide();
        }
        $('#table-container').html(this.patientsTable(
            {
                "patients" : this.collection.models,
                pageInfo : this.collection.info(),
                privilegeLevel: this.privilegeLevel
            })
         );

        this.pagination = new Pagination({ collection : this.collection });
        this.pagination.render();
        $( '#pagination' ).html( this.pagination.$el );

        $("#pageSize li").on("click", function() {

            var pageSize = $(this).text();

            if ( ! $(this).hasClass("active")  )
            {
                $("#pageSize li.active").removeClass("active");
                $(this).addClass("active");
                $("#pageSizeBtn").text(pageSize);
                self.collection.state.pageSize = pageSize;

                self.collection.getFirstPage();
            }

        });

        if(this.collection.models.length > 0)
        {
            $('#table-container').show();
            $('#pagination').show();
            $('#empty').hide();

            self.initializeTrs(this.showHideActionButton, "#dataTables");
        }
        else
        {
            $('#table-container').hide();
            $('#pagination').hide();
            $('#empty').show();
        }

    },
    showHideActionButton: function(flag) {
        GenericView.prototype.showHideActionButton(flag, "#deleteBtn", "#dataTables");
    },
    errorPatientsData: function(collection, xhr, options)
    {
        this.onErrorHandler(collection, xhr, options);
    },
	editPatient: function(e) {
	    window.location.href = "#Registration/"+$(e.currentTarget).parent().data("id");
	},
    deletePatient: function(e) {

        var self = this;

        var id = $(e.currentTarget).parent().data("id");

        url = ' /rest/api/customers/delete/' + id;

        var params = {
            "url": url,
            "collection": this.collection,
             "_showProgressBar": self.showActionProgressBar,
             "_hideProgressBar": self.hideActionProgressBar,
             "_deleteBtn": $('#deleteBtn')
        }
        popup.show(i18n.t("pageHeader.confirm_delete"), i18n.t("pageHeader.delete_msg"), "confirm_delete", params);

    }

});

module.exports = TheView;